export enum ResourceTypes {
  Brandfolder,
  Collection,
}

export enum Availability {
  Approved = 'approved',
  Draft = 'unpublished',
  Expired = 'expired',
  Unapproved = 'unapproved',
}

export enum Orientation {
  Landscape = 'landscape',
  Panorama = 'panorama',
  Portait = 'portrait',
  Square = 'square',
}

export interface Filters {
  availability?: Availability;
  // comments?: null; // I think this is an abandoned field, can delete if that's the case
  created_at?: Date;
  custom_fields?: { [key: string]: string };
  filetypes?: string[];
  // label?: null; // I think this is an abandoned field, can delete if that's the case
  orientation?: Orientation[];
  section?: string;
  tags?: string[];
}

export interface SearchFilter {
  created_at: Date;
  featured: boolean;
  filterable_id: number;
  filterable_type: ResourceTypes;
  id: number;
  key: string;
  label: string;
  position: number;
  query: string;
  updated_at: Date;
}

export interface SearchQueryOptions {
  searchKey?: string;
}

export enum SearchOperatorOptions {
  AND = 'AND',
  OR = 'OR',
  Quoted = 'Quoted',
  Strict = 'Strict',
}

export type SearchOption = { value: SearchOperatorOptions; label: string };
